import MarketRequestManage from "@/views/MarketRequest/MarketRequestManage";
import MarketRequestEdit from "@/views/MarketRequest/MarketRequestEdit";

const routes = [
 {
    path: '/MarketRequest/List',
    name: 'MarketRequestList',
    component: MarketRequestManage,
    meta:{requiredAuth:true}
  },
 {
    path: '/MarketRequest/Edit/:id',
    name: 'MarketRequestEdit',
    component: MarketRequestEdit,
    meta:{requiredAuth:true}
  },
]

export default routes